import { render, staticRenderFns } from "./PromotionDetailsModal.vue?vue&type=template&id=4aed2d3d"
import script from "./PromotionDetailsModal.vue?vue&type=script&lang=js"
export * from "./PromotionDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports